import axiosHandler from "interceptor/axiosInterceptor";

export const getGuestUsers = async (params) => {
  try {
    const response = await axiosHandler.get("/api/admin/users/guests", { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAthletes = async (params) => {
  try {
    const response = await axiosHandler.get("/api/admin/users/athletes", { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const toggleFacilityOwner = async (id, value) => {
  try {
    const response = await axiosHandler.patch(
      `/api/admin/users/athletes/${id}/facility-owner`,
      { is_facility_owner: value }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
